import { render, staticRenderFns } from "./ExpedienteCreateDescargoView.vue?vue&type=template&id=36cfc2d6&"
import script from "./ExpedienteCreateDescargoView.vue?vue&type=script&lang=js&"
export * from "./ExpedienteCreateDescargoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports